export const defaultGeneralStyleProps = {
  position: "initial",
  width: "100%",
  height: "100%",
  borderRadius: "0px 0px 4px 4px",
  borderWidth: "0px",
  backgroundColor: "#FFFFFF"
};